import { query } from 'utils/graphql';

// Actions
const LOAD_STATS = 'voyager/hyper/LOAD_STATS';
const LOAD_STATS_SUCCESS = 'voyager/hyper/LOAD_STATS_SUCCESS';
const LOAD_STATS_FAILURE = 'voyager/hyper/LOAD_STATS_FAILURE';
const LOAD_SITES = 'voyager/hyper/LOAD_SITES';
const LOAD_SITES_SUCCESS = 'voyager/hyper/LOAD_SITES_SUCCESS';
const LOAD_SITES_FAILURE = 'voyager/hyper/LOAD_SITES_FAILURE';

// Reducer
const initialState = {
  loading: false,
  stats: null,
  sites: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_STATS:
    case LOAD_SITES:
      return {
        ...state,
        loading: true,
      };
    case LOAD_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.data.stats,
      };
    case LOAD_SITES_SUCCESS: {
      const sites = action.data.sites.slice();
      sites.sort((left, right) => left.company.name.localeCompare(right.name));

      return {
        ...state,
        loading: false,
        sites,
      };
    }
    case LOAD_STATS_FAILURE:
    case LOAD_SITES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

// Action Creators
export function loadStats() {
  return {
    types: [LOAD_STATS, LOAD_STATS_SUCCESS, LOAD_STATS_FAILURE],
    promise: query`
      query GetStats {
        stats {
          siteCount
          pageCount
          facilityCount
          certificateCount
          unlaunchedSites {
            ...SiteProps
          }
          newSites {
            ...SiteProps
          }
          sitesPerMonth
          sectionUsage
          widgetUsage
          facilitiesPerCompany
        }
      }

      ${SiteFragment}
    `,
  };
}

export function loadSites() {
  return {
    types: [LOAD_SITES, LOAD_SITES_SUCCESS, LOAD_SITES_FAILURE],
    promise: query`
      query GetSites {
        sites {
          ...SiteProps
        }
      }
      ${SiteFragment}
    `,
  };
}

const SiteFragment = `
  fragment SiteProps on Site {
    companyId
    identifier
    dateAdded
    internalUrl
    company {
      name
      corporateUrl
      companySettingsUrl
    }
  }
`;
